import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { USER_PERMISSIONS_BY_EMAIL } from '../permissions/permissions-by-email';
import { ALL_USERS } from '../../admin/get-all-users';
import { USER_PERMISSIONS } from '../permissions';
import { useModal } from '../../../store/modals';
import { updateUserPermissionsAPI } from './api';

export function useUpdateUserPermissions({ selectedUser, onSuccess, onError } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    ({ userEmail, permissions }) => updateUserPermissionsAPI(userEmail, permissions),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        queryClient.invalidateQueries(USER_PERMISSIONS);
        queryClient.invalidateQueries(USER_PERMISSIONS_BY_EMAIL, selectedUser && selectedUser.email);
        if (onSuccess) {
          onSuccess();
        }
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'updateUserPermissionsSuccess',
            },
          });
        }, 100);
      },
      onError: () => {
        if (onError) {
          onError();
        }
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'genericErrorMessage',
            },
          });
        }, 100);
      },
    },
  );

  return {
    mutate,
    mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}
